import {Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import Icon, { COLORS, ICONS } from "../icon";
import classNames from 'classnames';
import './navigation-dropdown.scss';

interface NavigationDropdownProps {
	children: any;
	title: string | JSX.Element;
	className?: string;
	navdropClassName?: string;
	buttonClassName?: string;
	isArrow?: boolean
	edge?: 'left' | 'center' | 'right';
	renderCustomIcon?: () => JSX.Element;
	customAriaLabel?: string;
	setModalOpen?: Dispatch<SetStateAction<boolean>>
}
export default function NavigationDropdown({
	children,
	title,
	className,
	isArrow = true,
	buttonClassName = "no-style",
	navdropClassName,
	edge = 'left',
	renderCustomIcon,
	customAriaLabel,
	setModalOpen
}: NavigationDropdownProps): JSX.Element {
	const [open, setOpen] = useState(false);
	const self = useRef<HTMLButtonElement>(null);

	// on escape, close dropdown
	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (event.code === 'Escape' || event.key === 'Escape') {
				setOpen(false);
				setModalOpen?.(false);
			}
		};
		document.addEventListener("keydown", handleKeyDown);
		return () => {
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, []);

	const handleClose = (e: any) => {
		const path = e.path || e.composedPath();
		for (const item of path) {
			if (item?.classList?.contains('nav-dropdown-search')) return;
			if (self.current === item) { return; }
		}
		setOpen(false);
		setModalOpen?.(false);
	};

	useEffect(() => {
		if (open) {
			window.addEventListener('click', handleClose);
		}
		return () => window.removeEventListener('click', handleClose);
	}, [open]);

	const handleClick = (e: any) => {
		e.preventDefault();
		e.stopPropagation();
		setOpen(prev => !prev);
		setModalOpen?.(prev => !prev);
	};

	return (
		<div className={classNames("navigation-dropdown", className)}>
			<button role='button' onClick={handleClick} className={classNames(buttonClassName, { open })} ref={self} aria-label={customAriaLabel ? customAriaLabel : "Add photo"}>
				<span className="navdrop-title">{title}</span>
				{isArrow && (
					renderCustomIcon ? (
						renderCustomIcon()
					) : (
						<Icon name={ICONS.KEYBOARD_ARROW_DOWN} color={classNames(COLORS.MED_LIGHT_GRAY, "navdrop-arrow")} size={14} />
					)
				)}
			</button>
			{open &&
				<div className={classNames("navdrop-list", navdropClassName, { right: edge === 'right' }, { center: edge === 'center' })}>
					{children}
				</div>
			}
		</div>
	);
}